export default __webpack_public_path__ + "images/89ac7fa68046774501a0b8eda38e21c9-other_party.webp";